import { useState } from 'react';

interface Props {
  fetchFunction: (...args: any[]) => Promise<any>;
  getData?: boolean;
}

export const useFetch = ({ fetchFunction, getData = false }: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<any>();
  const fetchId = async (id: string) => onSubmit(id);
  const fetchValues = async (value: any) => onSubmit(undefined, value);
  const fetchProperties = async (id: string, values: any) => onSubmit(id, values);

  const onSubmit = async (id?: string, values?: any) => {
    try {
      setIsLoading(true);
      const resolve = await fetchFunction(id, values);
      if (resolve.message) {
        const error = new Error(resolve.message);
        setIsLoading(false);

        throw { error, data: resolve.data };
      }
      if (getData) setData(resolve);
      setIsLoading(false);
      return resolve;
    } catch (error) {
      setIsLoading(false);
      const errorCatch = new Error(error.error ?? error.message);
      throw { error : errorCatch, data: error.data};
    }
  };

  return { fetchId, fetchValues, fetchProperties, isLoading, data, setData };
};
